import React from 'react'
import { Redirect } from 'react-router-dom'
import { useSite } from '../../util/sites'

/**
 * BESSOnlyPage
 * - Wrap pages/components that should only be shown for sites with BESS.
 * - If selected site is not set yet -> shows a loading placeholder.
 * - If selected site has is_no_BESS -> redirects to /solar/analytics.
 *
 * Usage:
 * <BESSOnlyPage>
 *   <YourComponent />
 * </BESSOnlyPage>
 *
 * Optionally pass selectedSite prop to override redux value:
 * <BESSOnlyPage selectedSite={site}>...</BESSOnlyPage>
 */
export default function BESSOnlyPage({ children }) {

  const selectedSite = useSite().selectedSite?.value;

  if (!selectedSite) {
    return <div>Loading...</div>
  }

  const is_no_BESS = !selectedSite.is_BESS;

  if (is_no_BESS) {
    return <Redirect to="/solar/analytics" />
  }

  return <>{children}</>
}